// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"PayList--next-sr-only--3r_yaXN","dialog":"PayList--dialog--3SffOSg","btn":"PayList--btn--26mikir"};